import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 维护负责人 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 维护业务员 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 移除团队 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 导出 ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 业务区域 ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("查看关系网");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("流向权限");

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 取消负责人角色 ");

const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "16px",
    "margin-bottom": "10px"
  }
}, "该团队/层级团队暂无分账受益人，此负责人是否标记为分账受益人。", -1);

const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  style: {
    "color": "red"
  }
}, "若使用分账功能将以此标记判断是否为业务员下单后分成的管理者", -1);

const _hoisted_13 = /*#__PURE__*/_createTextVNode("暂不标记");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("标记");

import { computed, reactive, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getSalesmanTypeList, getUserInfoByStructureId, removeRelation, exportForAsync } from '@/request';
import Axios from '@/request/createAxiosInstalce';
import { exportUserInfo } from '@/request/api';
import { getVexTableProps, employeeTypeMap } from '@/config';
import { ElMessage, ElMessageBox } from 'element-plus';
import AddRelationPersonModal from './AddRelationPersonModal.vue';
import AddSalesmanAreaModal from './AddSalesmanAreaModal.vue';
import RelationNetModal from './relationNetModal.vue';
import FlowPermissionModal from './flowPermissionModal.vue';
import { SUPPLIER_CATEGORY, getLevelType, getIsSaleTeam } from '../../config';
export default {
  name: 'RelatedPersonnel',
  props: {
    dept: {
      type: Object,
      default: () => ({})
    } // supplierId: {
    //   type: String,
    //   defualt: ''
    // }

  },

  setup(__props) {
    const props = __props;
    const store = useStore();
    const accountRoleType = computed(() => store.state.user.userType);
    const form = ref({
      salesmanType: '',
      userKeyword: '',
      linkManKeyword: ''
    });
    const table = ref();
    const userType = ref(2);
    const showAddRelationPersonModal = ref(false);
    const showAddSalesmanAreaModal = ref(false);
    const actSalesman = ref(null);
    const exportAuth = ref(false);
    let total = 0;
    const route = useRoute();
    const storeType = route.query.storeType;
    const disabledSalesman = computed(() => {
      if (Number(storeType) === SUPPLIER_CATEGORY['厂家团队']) {
        return Number(props.dept.levelType) === 0 || getIsSaleTeam(props.dept.supplierCategory);
      }

      return Number(props.dept.levelType) === 0;
    });
    const salesmanTypeList = ref([]);
    getSalesmanTypeList().then(data => {
      salesmanTypeList.value = data;
    });

    function editSalesmanArea(row) {
      actSalesman.value = row;
      showAddSalesmanAreaModal.value = true;
    }

    function reset() {
      form.value = {
        salesmanType: '',
        userKeyword: '',
        linkManKeyword: ''
      };
      table.value.commitProxy('reload');
    }

    function addPerson(type) {
      userType.value = type;
      showAddRelationPersonModal.value = true;
    }

    function addSuccess() {
      table.value.commitProxy('reload');
    }

    function del() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm('确定要移出部门人员吗？人员被移出后才可以重新加入新的部门。', '移出团队').then(() => {
        removeRelation({
          ids: selectRows.map(i => i.supUserId).join(','),
          __repeat: true,
          __warn: false
        }).then(data => {
          if (data.code === '1001') {
            ElMessageBox.confirm(data.msg, '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning'
            }).then(() => {
              removeRelation({
                ids: selectRows.map(i => i.supUserId).join(','),
                comfirmStatus: '1',
                __repeat: true,
                __warn: false
              }).then(res => {
                if (res.success) {
                  ElMessage.success('操作成功!');
                  table.value.commitProxy('query');
                } else {
                  ElMessage.error(data.msg);
                }
              });
            }).catch(() => {});
          } else if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          } else {
            ElMessage.error(data.msg);
          }
        });
      });
    }

    function download() {
      const {
        salesmanType,
        userKeyword,
        linkManKeyword
      } = form.value;
      const {
        id
      } = props.dept;
      exportForAsync({
        salesmanType,
        userKeyword,
        linkManKeyword,
        levelType: getLevelType(storeType, props.dept),
        supplierId: props.dept.supplierId,
        structureId: props.dept.id,
        id,
        modularflag: 'userInfo',
        fileName: '人员信息',
        count: total,
        methodName: exportUserInfo.url
      });
    }

    watch(() => props.dept, () => {
      reset();
    });
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '登录账号',
        field: 'loginName',
        width: '150px',
        showOverflow: true
      }, {
        title: '姓名',
        field: 'linkMan',
        width: '120px',
        showOverflow: true
      }, {
        title: '联系电话',
        field: 'linkPhone',
        width: '120px',
        showOverflow: true
      }, {
        title: '团队角色',
        field: 'employeeTypeText',
        width: '150px',
        showOverflow: true
      }, {
        title: '业务员类型',
        field: 'salesmanType',
        width: '150px',
        showOverflow: true
      }, {
        title: '业务区域',
        field: 'salesmanAreaName',
        width: '200px',
        showOverflow: true
      }, {
        title: '所属团队',
        field: 'structureName',
        width: '200px',
        showOverflow: true
      }, {
        title: '首次加入时间',
        field: 'firstJoinTime',
        width: '180px',
        showOverflow: true
      }, {
        title: '上级团队',
        field: 'higherLevelDept',
        width: '200px',
        showOverflow: true
      }, {
        title: '操作',
        fixed: 'right',
        width: '300px',
        align: 'left',
        slots: {
          default: 'operation'
        }
      }],
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return row.higherLevelDept !== '--';
        }

      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getUserInfoByStructureId(_objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value), {}, {
              levelType: getLevelType(storeType, props.dept),
              supplierId: props.dept.supplierId,
              structureId: props.dept.id,
              __warn: true
            })).then(data => {
              total = data.total;
              data.rows.forEach(item => {
                item.employeeTypeText = employeeTypeMap[item.employeeType] || '未知';
              });
              exportAuth.value = data.exportAuth;
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    }); // 查看关系网

    const relationNetModal = reactive({
      visible: false,
      supUserId: undefined
    });

    function checkRelationNetHandle(data) {
      relationNetModal.supUserId = data.supUserId;
      relationNetModal.visible = true;
    } // 流向权限


    const flowPermissionModal = reactive({
      visible: false,
      supUserId: undefined
    });

    function setFlowPermissionHandle(data) {
      console.log(data);
      flowPermissionModal.visible = true;
      flowPermissionModal.supUserId = data.supUserId;
    } // 标记弹框


    const separateUserModal = ref({
      show: false,
      supplierId: '',
      supUserId: ''
    });

    function signHandle(supplierId, supUserId) {
      separateUserModal.value = {
        show: true,
        supplierId,
        supUserId
      };
    }

    function signConfirmHandle() {
      let url = `/admin/structure/saveSplitBeneficiaryAuth.json?supUserId=${separateUserModal.value.supUserId}&isSplitBeneficiary=1`;
      Axios.post(url).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
          separateUserModal.value = false;
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function toggleSignHandle(row) {
      let {
        supUserId,
        isSplitBeneficiary
      } = row;
      let signValue = isSplitBeneficiary === 1 ? 0 : 1;
      let url = `/admin/structure/saveSplitBeneficiaryAuth.json?supUserId=${supUserId}&isSplitBeneficiary=${signValue}`;
      Axios.post(url).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
          separateUserModal.value = false;
        } else {
          ElMessage.error(msg);
        }
      });
    }
    /**
     * 取消负责人角色
     */


    function cancelOwnerRoleHandle(row) {
      ElMessageBox.confirm('确定要取消该用户的负责人角色吗？', '取消负责人角色', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Axios.post('/admin/structure/cancelOwnerRole.json', new URLSearchParams({
          supUserId: row.supUserId
        })).then(res => {
          let {
            success,
            msg
          } = res.data;

          if (success) {
            ElMessage.success('操作成功');
            table.value.commitProxy('reload');
          } else {
            ElMessage.error(msg || '操作失败');
          }
        }).catch(error => {
          ElMessage.error('网络错误，请稍后重试');
        });
      }).catch(() => {// 用户取消操作
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        onKeydown: _cache[3] || (_cache[3] = _withKeys($event => table.value.commitProxy('reload'), ["enter"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "登录账号",
              prop: "userKeyword"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.userKeyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.userKeyword = $event),
                placeholder: "请输入登录账号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "联系人",
              prop: "linkManKeyword"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkManKeyword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.linkManKeyword = $event),
                placeholder: "请输入联系人"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队角色",
              prop: "employeeType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.employeeType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.employeeType = $event),
                placeholder: "请选择团队角色"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(employeeTypeMap), (text, id) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: text,
                    value: id,
                    key: id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          size: "small",
          onClick: _cache[5] || (_cache[5] = $event => addPerson(2))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "success",
          icon: "Plus",
          size: "small",
          onClick: _cache[6] || (_cache[6] = $event => addPerson(3)),
          disabled: _unref(disabledSalesman)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          type: "danger",
          icon: "Delete",
          size: "small",
          onClick: del
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), exportAuth.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          icon: "Download",
          size: "small",
          onClick: download
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })) : _createCommentVNode("", true)]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "LocationFilled",
          link: "",
          onClick: $event => editSalesmanArea(row)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"]), Number(_unref(storeType)) === _unref(SUPPLIER_CATEGORY)['共享团队'] ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          link: "",
          icon: "Paperclip",
          style: {
            "margin-left": "12px"
          },
          onClick: $event => checkRelationNetHandle(row)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _unref(accountRoleType) == '2' && Number(_unref(storeType)) === _unref(SUPPLIER_CATEGORY)['厂家团队'] ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          link: "",
          onClick: $event => setFlowPermissionHandle(row)
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          icon: row.isSplitBeneficiary === 0 ? 'Star' : 'StarFilled',
          style: {
            "margin-left": "0"
          },
          onClick: $event => toggleSignHandle(row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.isSplitBeneficiary === 0 ? '标记分账受益人' : '取消标记分账受益人'), 1)]),
          _: 2
        }, 1032, ["icon", "onClick"]), row.employeeType == 1 || row.employeeType == 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "primary",
          link: "",
          icon: "UserFilled",
          onClick: $event => cancelOwnerRoleHandle(row)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 16), _createVNode(AddRelationPersonModal, {
        modelValue: showAddRelationPersonModal.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showAddRelationPersonModal.value = $event),
        dept: __props.dept,
        userType: userType.value,
        supplierId: __props.dept.supplierId,
        onSuccess: addSuccess,
        onSign: signHandle
      }, null, 8, ["modelValue", "dept", "userType", "supplierId"]), _createVNode(AddSalesmanAreaModal, {
        modelValue: showAddSalesmanAreaModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showAddSalesmanAreaModal.value = $event),
        dept: __props.dept,
        actSalesman: actSalesman.value,
        supplierId: __props.dept.supplierId,
        onSuccess: _cache[9] || (_cache[9] = $event => table.value.commitProxy('reload'))
      }, null, 8, ["modelValue", "dept", "actSalesman", "supplierId"]), _createVNode(RelationNetModal, {
        modelValue: relationNetModal.visible,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => relationNetModal.visible = $event),
        supUserId: relationNetModal.supUserId
      }, null, 8, ["modelValue", "supUserId"]), _createVNode(FlowPermissionModal, {
        modelValue: flowPermissionModal.visible,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => flowPermissionModal.visible = $event),
        supUserId: flowPermissionModal.supUserId
      }, null, 8, ["modelValue", "supUserId"]), _createVNode(_component_el_dialog, {
        modelValue: separateUserModal.value.show,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => separateUserModal.value.show = $event),
        width: "500px",
        title: "标记分账受益人"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[12] || (_cache[12] = $event => separateUserModal.value.show = false)
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: signConfirmHandle
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_11, _hoisted_12]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};